import classes from "../../components/Services.module.css";
import backgroundImageHeading from "../../images/Property_Header_01.jpg";
import Head from "../../components/Head";

import LayoutPage from "./LayoutPage";
import PropertyFrom from "../../components/PropertyForm";
import Applynow from "../Applynow";
import { useState } from "react";
import PropertyAIDA from "../../components/Forms/PropertyAIDA";
import PropertySellers from "../../components/Forms/PropertySellers";
import PropertyOthers from "../../components/Forms/PropertyOTHERS";
import clockImage from "../../images/Fst Forward Property-02.png";
import NeedApplyImage from "../../images/What you need to apply.png";
import PayoutSpeedImg from "../../images/Payout Speed-04.png";
import Fast05 from "../../images/Fast-05.png";
import Reliable06 from "../../images/Reliable-06.png";
import ClientFocus from "../../images/Client Focused-07.png";
import Professional from "../../images/Professional-08.png";
import Transparent09 from "../../images/Transparent-09.png";
import Aida11 from "../../images/AIADA-11.jpg";
import PropSeller from "../../images/Prop Sellers-12.png";

function CardItems({ heading, imgSrc }) {
  return (
    <>
      <div className="col-md-7 col-lg-2 col-sm-7 col-xs-2">
        <div className="card shadow-none bg-white">
          <div className="card-body bg-white">
            <h4>{heading}</h4>
            <img
              src={imgSrc}
              alt="icon"
              className="img-fluid mb-2"
              width={70}
            />
          </div>
        </div>
      </div>
    </>
  );
}

function WhyChooseUs() {
  return (
    <>
      <div className={`text-center mt-2 mb-0 ${classes.WhyChooseUs}`}>
        <div className="row justify-content-center">
          <h3 className={`mt-3 ${classes.heading}`}>Why Choose Us ?</h3>
          <div className="row justify-content-center align-items-stretch mt-4">
            <CardItems heading={"Fast"} imgSrc={Fast05} />
            <CardItems heading={"Reliable"} imgSrc={Reliable06} />
            <CardItems heading={"Client Focused"} imgSrc={ClientFocus} />
          </div>
        </div>
        <div className="row justify-content-center">
          <CardItems heading={"Professional"} imgSrc={Professional} />
          <CardItems heading={"Transparent"} imgSrc={Transparent09} />
        </div>
      </div>
    </>
  );
}

function ApplyItem({
  heading,
  imgSrc,
  paragraph_top,
  paragraph_bot,
  setHandlerName,
  btnText,
  imgWidth,
}) {
  return (
    <>
      <div
        className={`col-md-6 col-lg-5 col-sm-8 col-xs-7 d-flex ${classes.ApplyItem} `}
      >
        <div className="card shadow-none  h-100 w-100 d-flex flex-column">
          <div className={`card-header ${classes.heading}`}>
            <h4>{heading}</h4>
          </div>
          <div className="card-body  d-flex flex-column">
            <div className="text-center mb-2 ">
              <img
                src={imgSrc}
                alt="icon"
                className="img-fluid mb-2"
                width={imgWidth}
              />
            </div>
          </div>
          {/* <div className="p-3 m-1 d-flex justify-content-lg-end align-items-center flex-row flex-grow-1">
            <h5 className=" col-5">{paragraph_top}</h5>
            <p className=" col-5">{paragraph_bot}</p>
          </div> */}
          <div className="row d-flex flex-column align-items-center">
            <div className="col-11 text-center">
              <h5 className="">{paragraph_top}</h5>
            </div>
            <div className="col-11">
              <p className="">{paragraph_bot}</p>
            </div>
          </div>
          <div className="m-3">
            <button
              className="btn btn-primary w-100 w-md-auto mt-auto mx-auto"
              onClick={setHandlerName}
            >
              {btnText}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

function PropertyBridgingFinance() {
  const [PropertySellersFormIsVisible, setPropertySellersIsVisible] =
    useState(false);
  const [PropertyAIDAIsVisible, setPropertyAIDAIsVisible] = useState(false);
  const [PropertyOthersIsVisible, setPropertyOthersIsVisible] = useState(false);
  function setAIDAHandler() {
    setPropertyAIDAIsVisible(true);
    setPropertySellersIsVisible(false);
    setPropertyOthersIsVisible(false);
  }
  function setSellersHandler() {
    setPropertySellersIsVisible(true);
    setPropertyAIDAIsVisible(false);
    setPropertyOthersIsVisible(false);
  }
  function setOthersHandler() {
    setPropertyOthersIsVisible(true);
    setPropertySellersIsVisible(false);
    setPropertyAIDAIsVisible(false);
  }
  return (
    <>
      <div
        className="position-relative d-flex justify-content-center align-items-center w-100"
        style={{
          backgroundImage: `url(${backgroundImageHeading})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          height: "75vh",
          maxHeight: "55vh",
          minHeight: "55vh", // uses viewport height (responsive)
        }}
      >
        <div className={classes.div_overlay}></div>
        <h1 className={classes.Page_Heading}>Property Bridging Finance</h1>
      </div>
      <LayoutPage
        Form={
          <>
            <h1 className={` text-center mt-3 ${classes.h1}`}>Apply Now</h1>
            <div className="row d-flex justify-content-center mb-4">
              <ApplyItem
                heading={"Property Sellers"}
                imgSrc={PropSeller}
                imgWidth={120}
                setHandlerName={setSellersHandler}
                btnText={"Apply Now"}
                paragraph_top={"Apply when you require an advance for:"}
                paragraph_bot={
                  <>
                    {" "}
                    <span>1. Personal Use/Proceeds</span> <br />
                    <span>2. Property Rates & Taxes</span>
                  </>
                }
              />

              {/* <ul className="list-inline d-flex flex-wrap justify-content-center">
                <li className="list-inline-item mb-2">
                  <button
                    className="btn btn-primary w-100 w-md-auto"
                    onClick={setAIDAHandler}
                  >
                    Property - AIDA Agents
                  </button>
                </li>
                <li className="list-inline-item mb-2">
                  <button
                    className="btn btn-primary w-100 w-md-auto"
                    onClick={setSellersHandler}
                  >
                    Property - Seller's
                  </button>
                </li>
                <li className="list-inline-item mb-2">
                  <button
                    className="btn btn-primary w-100 w-md-auto"
                    onClick={setOthersHandler}
                  >
                    Property - Others
                  </button>
                </li>
              </ul> */}
            </div>
            {PropertyAIDAIsVisible ? (
              <>
                <div className="container-fluid col-sm-10 col-lg-10 col-md-9  text-light">
                  {/* <h2 className={`text-centre ${classes.h2}`}>Property AIDA</h2> */}
                  <div
                    style={{
                      backgroundColor: "#113358",
                      overflow: "hidden",
                      borderRadius: "2%",
                      padding: "20px",
                    }}
                  >
                    <PropertyAIDA
                      heading={
                        "Use this form to apply for property bridging finance for yourself or your client"
                      }
                    />
                  </div>
                </div>
              </>
            ) : null}
            {PropertySellersFormIsVisible ? (
              <>
                <div className=" container-fluid col-sm-10 col-lg-10 col-md-9 text-light">
                  {/* <h2 className=" text-center">Property Seller's</h2> */}
                  <div
                    style={{
                      backgroundColor: "#113358",
                      overflow: "hidden",
                      borderRadius: "2%",
                      padding: "20px",
                    }}
                  >
                    <PropertySellers
                      heading={"Property Sellers - Apply here"}
                    />
                  </div>
                </div>
              </>
            ) : null}
            {PropertyOthersIsVisible ? (
              <>
                <div className=" container col-sm-12 col-md-12 col-lg-10">
                  {/* <h2 className=" text-center">Property Others</h2> */}
                  <div
                    style={{
                      backgroundColor: "#113358",
                      overflow: "hidden",
                      borderRadius: "2%",
                      padding: "20px",
                    }}
                  >
                    <PropertyOthers
                      heading={
                        "Use this form to apply for property bridging finance for yourself or your client"
                      }
                    />
                  </div>
                </div>
              </>
            ) : null}
          </>
        }
      >
        <div className="container row mx-auto">
          <div className="col-md-7 col-lg-12 mb-3 mb-md-0">
            <div className="col-12">
              <div className="row justify-content-center align-items-center align-items-end bg-white">
                <div className="col-lg-6 col-md-12 my-1 bg-light p-3">
                  <h2 className={classes.h4_bold}>
                    Property Bridging Finance ?
                  </h2>
                  <p className={classes.p}>
                    Property Bridging Finance is a short-term financial solution
                    designed to provide immediate access to funds while waiting
                    for a property transaction to be finalized.
                  </p>
                  <p className={classes.p}>
                    If you're waiting for the proceeds from your property sale,
                    this type of finance bridges the gap, ensuring you have the
                    necessary liquidity to manage your financial obligations.
                  </p>
                </div>
                <div className=" col-md-5 my-1 text-center">
                  <img
                    width={200}
                    src={clockImage}
                    className="img-fluid"
                    alt="clock"
                  />
                </div>
                <div className="row justify-content-center align-items-center align-items-stretch mt-2 w-100 bg-light p-2">
                  <div className="col-lg-4 col-md-7 col-sm-7 col-xs-5 d-flex flex-column text-center">
                    <h4 className={classes.h4}>What You Need to Apply:</h4>

                    <div
                      className="card d-flex align-items-center justify-content-center p-1"
                      style={{ height: 300 }}
                    >
                      <img
                        src={NeedApplyImage}
                        alt="Need to Apply"
                        className="img-fluid mb-1 mt-3"
                        width={100}
                      />

                      <div className="card-body">
                        <ol className={`${classes.border_ol} list-unstyled`}>
                          <li>01 - (OTP) Sale Agreement</li>
                          <li>02 - ID Document</li>
                          <li>03 - Transferring Attorney Details</li>
                        </ol>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-7 col-sm-7 d-flex flex-column text-center mt-3 mt-md-0">
                    <h4 className={classes.h4}>How Fast are Funds Paid Out?</h4>
                    <div
                      className="card d-flex align-items-center justify-content-center p-1"
                      style={{ height: 300 }}
                    >
                      <img
                        src={PayoutSpeedImg}
                        alt="Need to Apply"
                        className="img-fluid mb-1"
                        width={100}
                      />

                      <div className="card-body">
                        <p className={classes.p}>
                          Once all documents are signed, funds are typically
                          disbursed within 24 to 48 hours.
                        </p>
                        <p className={classes.p}>
                          This quick turnaround ensures that you can meet your
                          financial needs without the delay.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <WhyChooseUs />
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default PropertyBridgingFinance;
